import React from 'react';
import { useSelector } from 'react-redux';
import { Col, Avatar, Rate, Divider, Button, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import Slider from 'react-slick';
import { FaStar, FaChevronRight, FaChevronLeft } from 'react-icons/fa';
import moment from 'moment';

import { colors } from '../../../constants/colors';
import { getUserState } from '../../../store/user/selector';
import { getOrderState } from '../../../store/orders/selector';
import { Ratings } from '../../../store/orders/types';

interface RatingProps {
  item: Ratings;
}

export const RatingCards: React.FC<RatingProps> = ({ item }) => {
  const { userdetails, timeadded } = item;
  const time = moment(timeadded).add(100, 'days');
  const currenttime = moment().format();
  const rateddate = moment(time).isSame(currenttime)
    ? moment(time).calendar()
    : moment().format('ll');
  return (
    <div className="rating-card-carousel">
      <div className="ratings-card-container ">
        <Avatar size="large" src={userdetails?.image} />
        <div className="rating-card-title">{userdetails?.firstName}</div>
        <div className="extra-text">{rateddate}</div>
        <Rate character={<FaStar size={18} />} disabled value={item.rate} />
        <div className="rating-note">{item.message}</div>
      </div>
      <Divider className="rating-divider" type="vertical" />
    </div>
  );
};

export const RatingsContent: React.FC = () => {
  const { user } = useSelector(getUserState);
  const { ratings } = useSelector(getOrderState);
  const myratees = ratings.filter(r => r.ratedby !== user.userid);
  const { t } = useTranslation();
  const settings = {
    speed: 500,
    slidesToScroll: 1,
    infinite: true,
    arrows: false,
    slidesToShow: 6,
  };
  return (
    <Col span={24} className="rating-container">
      <div className="block-title">
        <span>{t('User Reviews')}</span>
        {myratees.length !== 0 && (
          <React.Fragment>
            <Button
              type="link"
              icon={<FaChevronLeft size={14} color={colors.nobel} />}
            />
            <Button
              type="link"
              icon={<FaChevronRight size={14} color={colors.nobel} />}
            />
          </React.Fragment>
        )}
      </div>
      {myratees.length === 0 ? (
        <Typography.Text type="secondary">{t('NO_REVIEWS')}</Typography.Text>
      ) : (
        <React.Fragment>
          {myratees.length > 6 ? (
            <Slider {...settings}>
              {myratees.map((item, i) => (
                <RatingCards key={i} item={item} />
              ))}
            </Slider>
          ) : (
            <div className="rating-card-carousel">
              {myratees.map((item, i) => (
                <RatingCards key={i} item={item} />
              ))}
            </div>
          )}
        </React.Fragment>
      )}
    </Col>
  );
};
